import { CSSProperties, RefObject } from 'react';

export type ContentContainerStyleParams = {
  popoverWidth?: string;
  triggerWidth?: number;
  portalEl?: RefObject<HTMLDivElement | null>;
  open: boolean;
};

/**
 * Build styles for the popover content container.
 * Handles both portal and non-portal rendering modes.
 */
export function buildContentContainerStyles({
  popoverWidth,
  triggerWidth,
  portalEl,
  open,
}: ContentContainerStyleParams): CSSProperties {
  return {
    width: popoverWidth || triggerWidth,
    ...(portalEl
      ? {
          position: 'fixed',
          top: 0,
          left: 0,
          height: 0,
          width: 0,
          overflow: 'hidden',
          zIndex: open ? 'auto' : -1,
        }
      : {}),
  };
}
